const TRANSIENT_GET_STATUS_CODES = [408, 502, 503, 504];

export const MAX_TRANSIENT_GET_RETRIES = 2;

export const isTransientGetError = (err: any): boolean => {
  const method = String(err?.config?.method ?? "").toLowerCase();
  if (method !== "get") return false;

  const status = Number(err?.response?.status);
  if (TRANSIENT_GET_STATUS_CODES.includes(status)) return true;
  if (err?.response) return false;

  return (
    ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT", "ECONNRESET"].includes(
      String(err?.code ?? "")
    ) || err?.message === "Network Error"
  );
};

export const transientGetRetryDelay = (retryCount: number): number =>
  400 * 2 ** retryCount;
